// Step 1: the booking-type chooser. Renders one card per type with name,
// duration, and description; selecting a card advances the flow.
// Implements: architecture.md v1.0 section 5 (GET /api/booking-types).

import type { JSX } from 'react';
import type { BookingType } from '../api/types.js';

function durationLabel(min: number): string {
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const rem = min % 60;
  return rem === 0 ? `${h} hr` : `${h} hr ${rem} min`;
}

export function BookingTypeList({
  types,
  onSelect,
}: {
  types: BookingType[];
  onSelect: (type: BookingType) => void;
}): JSX.Element {
  return (
    <ul className="type-grid" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {types.map((t, i) => (
        <li key={t.id} className={i < 3 ? `rise-${i + 1}` : 'rise'}>
          <button
            type="button"
            className="type-card"
            onClick={() => onSelect(t)}
            aria-label={`Book ${t.name}, ${durationLabel(t.durationMin)}`}
          >
            <div className="tc-top">
              <h3>{t.name}</h3>
              <span className="tc-dur">{durationLabel(t.durationMin)}</span>
            </div>
            {t.description ? <p>{t.description}</p> : null}
            <span className="tc-go">Select →</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
